(function(window) {
  function toggleDropdown(e) {
    const _d = $(e.target).closest(".dropdown");
    const _m = $(".dropdown-menu", _d);
    setTimeout(
      function() {
        const shouldOpen = e.type !== "click" && _d.is(":hover");
        _m.toggleClass("show", shouldOpen);
        _d.toggleClass("show", shouldOpen);
        $('[data-toggle="dropdown"]', _d).attr("aria-expanded", shouldOpen);
      },
      e.type === "mouseleave" ? 50 : 0
    );
  }

  $(document).ready(function() {
    // $('[data-navigate-url]').on('click', function() {
    //   window.location.href = $(this).data('navigate-url');
    // });
    //
    // $('.dialog-share').click(function(e) {
    //   e.preventDefault();
    //   window.open(
    //     $(this).attr('href'),
    //     'fbShareWindow',
    //     'height=450, width=550, top=' +
    //     ($(window).height() / 2 - 275) +
    //     ', left=' +
    //     ($(window).width() / 2 - 225) +
    //     ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0',
    //   );
    //   return false;
    // });
    //
    // // $('.text-dotdotdot').dotdotdot({});
    //
    // $('.scroll-to').on('click', function() {
    //   $.scrollTo($(this).attr('data-navigate-section'), 800, { offset: -80 });
    // });
    //
    // $('.show-search').on('click', function() {
    //   $('.search-sticky').addClass('sticky');
    //   $('.search-sticky .search-bar input[name="query"]').focus();
    //
    //   return false;
    // });
    //
    // $('.search-sticky .search-bar input[name="query"]').on('blur', function() {
    //   $('.search-sticky').removeClass('sticky');
    //   $('.typeahead').typeahead('val', '');
    // });

    // $("#container").on("click", "a[data-href]", function(e) {
    //   e.preventDefault();
    //
    //   let $anchor = $(this);
    //   let $target = $($anchor.data("target"));
    //   let msg;
    //   let data = {};
    //
    //   if ($anchor.data("target-title")) {
    //     $target.find(".modal-title").text($anchor.data("target-title"));
    //   }
    //
    //   if ($(this).attr("data-selected-ids")) {
    //     data["ids"] = $(this).attr("data-selected-ids");
    //   }
    //
    //   $.ajax({
    //     url: $anchor.data("href"),
    //     type: "GET",
    //     dataType: "json", //expect json as return
    //     data: data,
    //     beforeSend: function(jqXHR, settings) {
    //       msg = Messenger().post({
    //         message: "Processing...",
    //         type: "info",
    //         hideAfter: 20,
    //         showCloseButton: true,
    //         hideOnNavigate: true,
    //         singleton: true
    //       });
    //     },
    //     error: function(e) {
    //       msg.update({
    //         message: sprintf(
    //           '<div class="">%s %s</div>',
    //           e.responseJSON.hasOwnProperty("exception")
    //             ? e.responseJSON.exception + "."
    //             : "",
    //           e.responseJSON.message
    //         ),
    //         type: "error"
    //       });
    //
    //       $target.modal("hide");
    //
    //       setTimeout(function() {
    //         msg.hide();
    //       }, 5000);
    //     },
    //     success: function(result) {
    //       if (result.hasOwnProperty("html")) {
    //         $target.find(".modal-body").html(result.html);
    //
    //         setTimeout(function() {
    //           $target.find("form :input:enabled:visible:first").focus();
    //         }, 250);
    //       }
    //
    //       if (result.success != null && !result.success) {
    //         msg.update({ message: result.message, type: "error" });
    //       } else {
    //         if (result.message != null && result.message.length > 0) {
    //           msg.update({ message: result.message, type: "success" });
    //         } else {
    //           msg.update({ message: "Done!", type: "success" });
    //
    //           $target.trigger("fetched.modal");
    //         }
    //       }
    //
    //       setTimeout(function() {
    //         msg.hide();
    //       }, 500);
    //     }
    //   });
    // });

    // Disabled because ajaxFormModal() is handling this scenario already
    // $('#container').on('click', 'a[data-modal-href]', function (e) {
    //   e.preventDefault();
    //
    //   let $anchor = $(this);
    //   let data = {};
    //
    //   if ($(this).attr("data-selected-ids")) {
    //     data["ids"] = $(this).attr("data-selected-ids");
    //   }
    //
    //   ajaxModalRequest({
    //     url: $anchor.data('modal-href'),
    //     target: $anchor.data('target'),
    //     element: $anchor,
    //     data,
    //   });
    // });

    $.initialize(".show-tip", function() {
      tippy(this, {
        content: function(el) {
          if ($(el).attr('data-title-id')?.length) {
            return $($(el).attr('data-title-id')).html();
          }

          if ($(el).attr('data-tippy-content')?.length) {
            return $(el).attr('data-tippy-content');
          }

          // const title = $(el).attr('title');
          // $(el).attr('title', '');

          return $(el).attr('title');
        }
      });
    });

    $(document).on("pjax:start", function() {
      NProgress.start();
    });
    $(document).on("pjax:end", function() {
      NProgress.done();
    });

    $(document).on("pjax:timeout", function(event) {
      console.info("pjax timeout");
      // Prevent default timeout redirection behavior
      event.preventDefault();
    });

    $(document).on("pjax:error", function(
      event,
      xhr,
      textStatus,
      errorThrown,
      options
    ) {
      console.info(options, "options");
      console.info(errorThrown, "errorThrown");
      console.info(textStatus, "textStatus");
      console.info(xhr, "xhr");
      return false;
    });

    $(document).pjax("[data-pjax] a, a[data-pjax]", "#pjax-container");

    $(document).on("submit", "form[data-pjax]", function(event) {
      $.pjax.submit(event, "#pjax-container", {
        scrollTo: true
      });
    });

    $.pjax.defaults.timeout = 3000;
    $.pjax.defaults.maxCacheLength = 0;

    // navbar dropdown on hover
    // $('body')
    //   .on('mouseenter mouseleave', '.dropdown', toggleDropdown)
    //   .on('click', '.dropdown-menu a', toggleDropdown);

    // if ($('.grid-masonry').length) {
    // $('.grid-masonry').isotope({
    //   // options
    //   itemSelector: '.grid-item',
    //   layoutMode: 'fitRows'
    // });

    /* var elem = document.querySelector('.grid-masonry');
      var iso = new Isotope( elem, {
        // options
        itemSelector: '.grid-item',
        // layoutMode: 'masonryHorizontal',
        // percentPosition: true,
        // masonry: {
        //   // use element for option
        //   columnWidth: '.grid-sizer'
        // }
        // masonryHorizontal: {
        //   rowHeight: 50
        // },
        layoutMode: 'fitRows',
        percentPosition: true,
        masonry: {
          columnWith: '.grid-sizer'
        }
      });*/

    // }

    // $('.text-dotdotdot').each(function (i, el) {
    //   new Dotdotdot(el, {});
    // });

    // dot.API.truncate();
    // dot.API.watch();

    // $('#container').on('click', 'a[data-modal-href]', function (e) {
    //   e.preventDefault();
    //
    //   ajaxFormRequest({
    //     url: $(this).data('modal-href'),
    //     target: $(this).data('target')
    //   });
    // });

    $("#container").on("click", ".modal .ajax-submit", function(e) {
      // We don't want this to act as a link so cancel the link action
      e.preventDefault();

      // Find form and submit it
      $(this)
        .closest(".modal")
        .find("form")
        .submit();
    });

    $.initialize("a.qtip", function() {
      tippy(this, {
        content: function(el) {
          return $(el).attr("title");
        }
      });

      // $(this).qtip({
      // 	style: {
      // 		name: 'blue',
      // 		tip: true ,
      // 		border: {
      // 			width: 2,
      // 			radius: 8
      // 		}
      // 	},
      // 	position: {
      // 		corner: {
      // 		   target: 'bottomMiddle', // Position the tooltip above the link
      // 		   tooltip: 'topMiddle'
      // 		},
      // 		adjust: {
      // 		   screen: true // Keep the tooltip on-screen at all times
      // 		}
      // 	},
      // 	show: {
      // 		delay: 50
      // 	}
      // });
      //
      // if($(this).attr('href').indexOf('#') != -1) {
      // 	$(this).click(function(){
      // 		return false;
      // 	});
      // }
    });

    setTimeout(function() {
      // $('#flashnotice-container').hide('highlight', 2000);
    }, 1500);

    $(document).on("click", ".table-data a.record-remove", function(e) {
      var $anchor = $(this);
      var $row = $(this).parents("tr");

      ajaxPost({
        url: $anchor.attr("href"),
        message:
          'You <span class="text-danger"">cannot</span> recover deleted record. Are you sure to continue?',
        title: "Delete record",
        btnMain: {
          label: "Delete",
          className: "btn-danger"
        },
        success: function(result) {
          $row.hide("highlight", 250);
        }
      });

      return false;
    });

    $("#container").on(
      "click",
      "ul.button-list li a.record-suspend",
      function() {
        var anchor = $(this);
        var row = $(this).parents("tr, .sortable-row");

        if (!anchor.hasClass("disabled")) {
          bootbox.confirm({
            centerVertical: true,
            message: "Are you sure to suspend current record?",
            callback: function(result) {
              if (result) {
                $.ajax({
                  url: anchor.attr("href"),
                  type: "GET", //request is a POSt request
                  dataType: "json", //expect json as return
                  success: function(
                    result //trigger this on success
                  ) {
                    if (result.success != null && !result.success) {
                      bootbox.dialog({
                        message: result.html,
                        title: "Error while suspending record",
                        buttons: {
                          main: {
                            label: "OK",
                            className: "btn-primary",
                            callback: function() {}
                          }
                        }
                      });
                    } else {
                      anchor.addClass("disabled");
                      row
                        .find("td.status-icon a")
                        .removeClass("record-active")
                        .addClass("record-inactive")
                        .attr("title", "inactive");

                      row
                        .find(".badge-status")
                        .removeClass("badge-active")
                        .addClass("badge-inactive")
                        .attr("title", "inactive")
                        .text("inactive");

                      row.show("highlight", 1000);
                    }
                  }
                });
              }
            }
          });
        }

        return false;
      }
    );

    $("#container").on(
      "click",
      ".button-list a.record-approve-price",
      function() {
        var anchor = $(this);
        var row = $(this).parents("tr");

        var message = !anchor.hasClass("approved")
          ? "Are you sure to approve current record?"
          : "Are you sure to approve current record?";

        $.ajax({
          url: anchor.attr("href"),
          type: "GET", //request is a POSt request
          dataType: "json", //expect json as return
          beforeSend: function(jqXHR, settings) {
            //anchor.data('original-text', anchor.html());
            //anchor.html('<i class="fa fa-circle-o-notch fa-spin"></i>');
            anchor.addClass("inline-loading icon");

            msg = Messenger().post({
              message: !anchor.hasClass("approved")
                ? "Approving..."
                : "Reverting...",
              type: "info",
              hideAfter: 20,
              showCloseButton: true,
              hideOnNavigate: true
            });
          },
          error: function() {
            //anchor.html(anchor.data('original-text'));
            anchor.removeClass("inline-loading icon");

            msg.update({
              message: "Error encountered while processing the request",
              type: "error"
            });

            setTimeout(function() {
              msg.hide();
            }, 2000);
          },
          success: function(result) {
            //anchor.html(anchor.data('original-text'));

            anchor.removeClass("inline-loading icon");

            if (result.success != null && !result.success) {
              msg.update({ message: result.message, type: "error" });
            } else {
              result.model.price_approved
                ? anchor.addClass("approved")
                : anchor.removeClass("approved");

              //row.find('td a.label-flat').removeClass().addClass("label-flat label-sm label-"+result.status_class).text(result.model_status);
              anchor.attr("href", result.href);

              anchor.attr(
                "title",
                result.model.price_approved ? "revert price" : "approve price"
              );

              // anchor.qtip('api').updateContent(anchor.attr('title'));

              row.show("highlight", 1000);

              if (result.message != null && result.message.length > 0) {
                msg.update({ message: result.message, type: "success" });

                //$(result.message).hide().insertBefore('div.control-container').fadeIn();

                // setTimeout(function(){
                // $('#flashnotice-container').fadeOut('slow', function(){
                // $(this).remove();
                // })
                // }, 1000);
              } else {
                msg.update({ message: "Done!", type: "success" });
                //msg.hide();
              }
            }

            setTimeout(
              function() {
                msg.hide();
              },
              result.success ? 500 : 2000
            );
          }
        });

        return false;
      }
    );

    $("#container").on("click", ".button-list a.record-confirm", function() {
      var anchor = $(this);
      var row = $(this).parents("tr");

      var message = !anchor.hasClass("confirmed")
        ? "Are you sure to confirm current record?"
        : "Are you sure to confirm current record?";

      $.ajax({
        url: anchor.attr("href"),
        type: "GET", //request is a POSt request
        dataType: "json", //expect json as return
        beforeSend: function(jqXHR, settings) {
          //anchor.data('original-text', anchor.html());
          //anchor.html('<i class="fa fa-circle-o-notch fa-spin"></i>');
          anchor.addClass("inline-loading icon");

          msg = Messenger().post({
            message: !anchor.hasClass("confirmed")
              ? "Confirming..."
              : "Reverting...",
            type: "info",
            hideAfter: 20,
            showCloseButton: true,
            hideOnNavigate: true
          });
        },
        error: function() {
          //anchor.html(anchor.data('original-text'));
          anchor.removeClass("inline-loading icon");

          msg.update({
            message: "Error encountered while processing the request",
            type: "error"
          });

          setTimeout(function() {
            msg.hide();
          }, 2000);
        },
        success: function(result) {
          //anchor.html(anchor.data('original-text'));

          anchor.removeClass("inline-loading icon");

          if (result.success != null && !result.success) {
            msg.update({ message: result.message, type: "error" });
          } else {
            result.model.is_confirmed
              ? anchor.addClass("confirmed")
              : anchor.removeClass("confirmed");

            //row.find('td a.label-flat').removeClass().addClass("label-flat label-sm label-"+result.status_class).text(result.model_status);
            anchor.attr("href", result.href);

            anchor.attr(
              "title",
              result.model.is_confirmed ? "revert" : "confirm"
            );

            // anchor.qtip('api').updateContent(anchor.attr('title'));

            row.show("highlight", 1000);

            if (result.message != null && result.message.length > 0) {
              msg.update({ message: result.message, type: "success" });

              //$(result.message).hide().insertBefore('div.control-container').fadeIn();

              // setTimeout(function(){
              // $('#flashnotice-container').fadeOut('slow', function(){
              // $(this).remove();
              // })
              // }, 1000);
            } else {
              msg.update({ message: "Done!", type: "success" });
              //msg.hide();
            }
          }

          setTimeout(
            function() {
              msg.hide();
            },
            result.success ? 500 : 2000
          );
        }
      });

      return false;
    });

    $("#container").on(
      "click",
      ".button-list a.record-lock",
      function() {
        const anchor = $(this);
        const row = $(this).parents("tr");

        // let message = !anchor.hasClass("locked")
        //   ? "Are you sure to lock current record?"
        //   : "Are you sure to unlock current record?";

        $.ajax({
          url: anchor.attr("href"),
          type: "GET", //request is a POSt request
          dataType: "json", //expect json as return
          beforeSend: function(jqXHR, settings) {
            //anchor.data('original-text', anchor.html());
            //anchor.html('<i class="fa fa-circle-o-notch fa-spin"></i>');
            anchor.addClass("inline-loading icon");

            msg = Messenger().post({
              message: !anchor.hasClass("locked")
                ? "Locking..."
                : "Unlocking...",
              type: "info",
              hideAfter: 20,
              showCloseButton: true,
              hideOnNavigate: true
            });
          },
          error: function() {
            //anchor.html(anchor.data('original-text'));
            anchor.removeClass("inline-loading icon");

            msg.update({
              message: "Error encountered while processing the request",
              type: "error"
            });

            setTimeout(function() {
              msg.hide();
            }, 2000);
          },
          success: function(result) {
            //anchor.html(anchor.data('original-text'));
            anchor.removeClass("inline-loading icon");

            if (result.success != null && !result.success) {
              msg.update({ message: result.message, type: "error" });
            } else {
              result.model.is_locked
                ? anchor.addClass("locked")
                : anchor.removeClass("locked");

              //row.find('td a.label-flat').removeClass().addClass("label-flat label-sm label-"+result.status_class).text(result.model_status);
              anchor.attr("href", result.href);

              anchor.attr(
                "title",
                result.model.is_locked ? "unlock" : "lock"
              );

              // anchor.qtip('api').updateContent(anchor.attr('title'));

              row.show("highlight", 1000);

              if (result.message != null && result.message.length > 0) {
                msg.update({ message: result.message, type: "success" });

                //$(result.message).hide().insertBefore('div.control-container').fadeIn();

                // setTimeout(function(){
                // $('#flashnotice-container').fadeOut('slow', function(){
                // $(this).remove();
                // })
                // }, 1000);
              } else {
                msg.update({ message: "Done!", type: "success" });
                //msg.hide();
              }
            }

            setTimeout(
              function() {
                msg.hide();
              },
              result.success ? 500 : 2000
            );
          }
        });

        return false;
      }
    );

    let tableBulk = $.tableBulk({});
    tableBulk.capture();

    $('[data-date-mask]').mask('9999-99-99');

    $('.hierarchy-select').hierarchySelect({
      width: '100%',
      // initialValueSet: true,
      onChange: function(value) {
      },
    });
  });
})(window);
